// src/utils/URLS.js - ACTUALIZADO CON ENDPOINT DE FINALIZACIÓN
const BASE_URL = process.env.REACT_APP_BASE_URL;

// Auth endpoints
export const AUTH = {
  LOGIN: `${BASE_URL}/auth/login`,
  CHANGE_PASSWORD: `${BASE_URL}/auth/change-password`,
};

// Assistant (AI) endpoints
export const ASSISTANT = {
  CHAT: `${BASE_URL}/assistant/chat`,
  SEND_EMAIL: `${BASE_URL}/assistant/send-email`,
};

// Person related endpoints
export const PERSONS = {
 // SEARCH: `${BASE_URL}/persons/`,
  LIST: `${BASE_URL}/persons/`,
  UPDATE: `${BASE_URL}/persons/person/`,
  CREATE: `${BASE_URL}/persons/person`,
  COMPANY_CREATE: `${BASE_URL}/persons/company`,
  V2: `${BASE_URL}/persons/v2/`,
  //GET_CLIENTS: `${BASE_URL}/persons?regime=Client`,
  //GET_EMPLOYEES: `${BASE_URL}/persons?regime=Employee`,
  ASSIGN_TOOL: (personId) => `${BASE_URL}/persons/${personId}/assign-tool`,
};

// Company related endpoints
export const COMPANIES = {
  CREATE: `${BASE_URL}/persons/company`,
  UPDATE: `${BASE_URL}/persons/company/`,
};

// Tool related endpoints
export const TOOLS = {
  LIST: `${BASE_URL}/tools/`,
  CREATE: `${BASE_URL}/tools/`,
  SEARCH: `${BASE_URL}/tools`,
  ASSIGN: `${BASE_URL}/tools/`,
  BY_PERSON: `${BASE_URL}/tools/person/`,
};

// Assigned Tools endpoints
export const ASSIGNED_TOOLS = {
  LIST: `${BASE_URL}/assigned-tools/`,
};

// Works related endpoints - ✅ ACTUALIZADO CON ENDPOINT DE FINALIZACIÓN
export const WORKS = {
  LIST: `${BASE_URL}/works/`,
  SEARCH: `${BASE_URL}/works`,
  BY_PERSON: `${BASE_URL}/works/person/`,
  FINALIZE: (workId) => `${BASE_URL}/works/${workId}/end`, // ✅ NUEVO ENDPOINT
};

// Documents related endpoints
export const DOCUMENTS = {
  LIST: `${BASE_URL}/documents/`,
  NAMES: `${BASE_URL}/documents/names`,
  EXPIRATIONS: `${BASE_URL}/documents/next-expirations`,
  BY_PERSON: `${BASE_URL}/documents/person/`,
};

// Inspections related endpoints
export const INSPECTIONS = {
  LIST: `${BASE_URL}/inspections/`,
  EXPIRATIONS: `${BASE_URL}/inspections/next-expirations`,
  BY_PERSON: `${BASE_URL}/inspections/person/`,
  RESPONSABLES: `${BASE_URL}/inspections/responsables`,
  BY_TOOL: `${BASE_URL}/inspections/assigned-tool/`,
  SEARCH: `${BASE_URL}/inspections`,
};

// Training related endpoints
export const TRAININGS = {
  LIST: `${BASE_URL}/trainings/`,
  SEARCH: `${BASE_URL}/trainings`,
  BY_PERSON: `${BASE_URL}/trainings/person/`,
    INSTRUCTORS: `${BASE_URL}/trainings/instructors`,
};

// Exponer también las URLs planas para mantener compatibilidad durante la migración
// Estas se pueden ir eliminando a medida que el código se actualice al nuevo formato
export const URL_LOGIN = AUTH.LOGIN;
export const API_URL_PERSONS_SEARCH = PERSONS.SEARCH;
export const API_URL_PERSONS = PERSONS.LIST;
export const API_URL_PERSONS_UPDATE = PERSONS.UPDATE;
export const API_URL_PERSON_CREATE = PERSONS.CREATE;
export const API_URL_COMPANY_CREATE = COMPANIES.CREATE;
export const API_URL_COMPANY_UPDATE = COMPANIES.UPDATE;
export const API_URL_TOOLS_ASSIGN = TOOLS.ASSIGN;
export const API_URL_ASSIGNEDTOOLS = ASSIGNED_TOOLS.LIST;
export const API_URL_OBRAS_CLIENTE = `${BASE_URL}/obras/cliente/`;
export const API_URL_OBRAS_EMPLEADO = `${BASE_URL}/obras/empleado/`;
export const API_URL_DOCUMENTS = DOCUMENTS.LIST;
export const API_URL_DOCUMENTS_EXPIRATIONS = DOCUMENTS.EXPIRATIONS;
export const API_URL_INSPECTIONS = INSPECTIONS.LIST;
export const API_URL_INSPECTIONS_EXPIRATIONS = INSPECTIONS.EXPIRATIONS;
export const API_URL_INSPECTION_PERSON = INSPECTIONS.BY_PERSON;
export const API_URL_INSPECTION_TOOL = INSPECTIONS.BY_TOOL;
export const API_URL_INSPECTIONS_SEARCH = INSPECTIONS.SEARCH;
export const API_URL_TOOLS = TOOLS.LIST;
export const API_URL_TOOLS_CREATE = TOOLS.CREATE;
export const API_URL_TOOlS_SEARCH = TOOLS.SEARCH;
export const API_URL_WORKS = WORKS.LIST;
export const API_URL_WORKS_SEARCH = WORKS.SEARCH;
export const API_URL_TRAININGS = TRAININGS.LIST;
export const API_URL_TRININGS_SEARCH = TRAININGS.SEARCH;
export const API_URL_TRAININGS_v2 = TRAININGS.BY_PERSON;
export const API_URL_WORKS_v2 = WORKS.BY_PERSON;
export const API_URL_TOOLS_v2 = TOOLS.BY_PERSON;
export const API_URL_DOCUMENTS_v2 = DOCUMENTS.BY_PERSON;
export const API_URL_INSPECTIONS_v2 = INSPECTIONS.BY_PERSON;
export const API_URL_PERSONS_v2 = PERSONS.V2;